























import { Component, Vue } from 'vue-property-decorator'
import SlideBar from '@/apps/open/views/fileCenter/components/SlideBar.vue'
import DocRate from './components/DocRate.vue'
import privateDocMenu from './PrivateDocMenu.json'
import priMiddleDocMenu from './PriMiddleDocMenu.json'
@Component({
  components: {
    SlideBar,
    DocRate
  }
})
export default class EnterpriseInnerApp extends Vue {
  sliderBarOpeneds = ['', '']
  slideBarActive = ''
  breadList = []
  dropdownList = []
  dropdownSelectUrl = ''

  created () {
    this.initSlideBar(this.$route.path)
    this.initBreadcrumb(this.$route)
  }

  beforeRouteUpdate (to: any, from: any, next: any) {
    this.initSlideBar(to.path)
    this.initBreadcrumb(to)
    next()
  }

  mounted () {
    window.addEventListener('scroll', this.onBodyScroll, true)
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onBodyScroll, true)
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  get fileCenterMenu () {
    const publicDocMenu = [
      {
        path: '/docs/enterprise-inner-app/admin-config',
        name: '管理中心配置',
        icon: '',
        children: [
          {
            path: '/docs/enterprise-inner-app/admin-config/create-app',
            name: '应用创建',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/admin-config/apply-permission',
            name: '权限申请',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/admin-config/basic-config',
            name: '基本设置',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/admin-config/auth-config',
            name: '认证配置',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/admin-config/sync-config',
            name: '同步配置',
            icon: ''
          }
        ]
      },
      {
        path: '/docs/enterprise-inner-app/authorize',
        name: '企业授权',
        icon: '',
        children: [
          {
            path: '/docs/enterprise-inner-app/authorize/access-know',
            name: '接入须知',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/authorize/api-list',
            name: 'API列表',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/authorize/python-sign',
            name: '签名说明',
            icon: ''
          }
        ]
      },
      {
        path: '/docs/enterprise-inner-app/adressbook',
        name: '企业通讯录',
        icon: '',
        children: [
          {
            path: '/docs/enterprise-inner-app/adressbook/access-know',
            name: '接入须知',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/adressbook/api-list',
            name: 'API列表',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/adressbook/ext-api-list',
            name: '扩展API列表',
            icon: ''
          }
        ]
      },
      {
        path: '/docs/enterprise-inner-app/team',
        name: '企业团队',
        icon: '',
        children: [
          {
            path: '/docs/enterprise-inner-app/team/general',
            name: '普通团队',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/team/department',
            name: '部门团队',
            icon: ''
          }
        ]
      },
      {
        path: '/docs/enterprise-inner-app/msg-subscribe',
        name: '消息订阅',
        icon: '',
        children: [
          {
            path: '/docs/enterprise-inner-app/msg-subscribe/callback',
            name: '回调API列表',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/msg-subscribe/go-decode',
            name: 'Go解密示例',
            icon: ''
          },
          {
            path: '/docs/enterprise-inner-app/msg-subscribe/python-decode',
            name: 'Python解密示例',
            icon: ''
          }
        ]
      },
      {
        path: '/docs/enterprise-inner-app/demo',
        name: 'DEMO',
        icon: ''
      }
    ]
    return this.isPrivate ? this.isPriDocMiddle ? priMiddleDocMenu.doc_middle_app : privateDocMenu.enterprise_inner_app : publicDocMenu
  }

  jumpPage (path: string) {
    this.$router.push(path)
  }

  onBodyScroll () {
    let scrollTop = document.body.scrollTop + document.documentElement.scrollTop
    let elHeaderHeight = document.getElementsByClassName('el-header')[0].clientHeight
    let elAside = document.getElementsByClassName('el-aside')[0] as HTMLElement
    let elMain = document.getElementsByClassName('el-main')[0] as HTMLElement
    let elBreadCrumb = document.getElementsByClassName('el-breadcrumb')[0] as HTMLElement

    if (scrollTop > elHeaderHeight) {
      elAside.style.position = 'fixed'
      elAside.style.top = '66px'
      elMain.style.marginLeft = '231px'
      elBreadCrumb.style.position = 'fixed'
      elBreadCrumb.style.top = '66px'
    } else {
      elAside.style.position = 'relative'
      elAside.style.top = '0px'
      elMain.style.marginLeft = '0px'
      elBreadCrumb.style.position = 'relative'
      elBreadCrumb.style.top = '0px'
    }
  }

  initSlideBar (toIndex: string) {
    this.slideBarActive = toIndex
  }

  initBreadcrumb (curRoute: any) {
    let matched = curRoute.matched.filter((item: any) => item.meta.title)
    this.breadList = matched
    this.dropdownList = curRoute.meta.aimtilelist
  }

  dropdownItemOnclick (index: number) {
    this.dropdownSelectUrl = '#s' + index
  }
}
